/**
 * View component for /sentiment-questions
 *
 * Generic sentimentQuestion list view. Defaults to 'all' with:
 * this.props.dispatch(sentimentQuestionActions.fetchListIfNeeded());
 *
 * NOTE: See /product/views/ProductList.js.jsx for more examples
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import actions
import * as sentimentQuestionActions from '../sentimentQuestionActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";
import Breadcrumbs from '../../../global/components/routing/Breadcrumbs.js.jsx';

// import sentimentQuestion components
import SentimentQuestionLayout from '../components/SentimentQuestionLayout.js.jsx';
import SentimentQuestionListItem from '../components/SentimentQuestionListItem.js.jsx';

// import sentimentQuestion css modules
import sentimentQuestionStyles from '../sentimentQuestionModuleStyles.css';

import SentimentQuestionPreviewModal from '../components/SentimentQuestionPreviewModal.js.jsx';

class SentimentQuestionList extends Base {
  constructor(props) {
    super(props);
    this.state = {
      sentimentModalVisible: false 
    }
    this._bind(
      '_toggleSentimentModal'
    )
  }

  componentDidMount() {
    // fetch a list of your choice
    this.props.dispatch(sentimentQuestionActions.fetchListIfNeeded()); // defaults to 'all'
  }

  _toggleSentimentModal() {
    this.setState({sentimentModalVisible: !this.state.sentimentModalVisible}); 
  }

  render() {
    const { sentimentQuestionStore, location } = this.props;

    /**
     * Retrieve the list information and the list items for the component here.
     *
     * NOTE: if the list is deeply nested and/or filtered, you'll want to handle
     * these steps within the mapStoreToProps method prior to delivering the
     * props to the component.  Othwerwise, the render() action gets convoluted
     * and potentially severely bogged down.
     */

    // get the sentimentQuestionList meta info here so we can reference 'isFetching'
    const sentimentQuestionList = sentimentQuestionStore.lists ? sentimentQuestionStore.lists.all : null;

    /**
     * use the reducer getList utility to convert the all.items array of ids
     * to the actual sentimentQuestion objetcs
     */
    const sentimentQuestionListItems = sentimentQuestionStore.util.getList("all");

    /**
     * NOTE: isEmpty is is usefull when the component references more than one
     * resource list.
     */
    const isEmpty = !sentimentQuestionListItems || !sentimentQuestionList;

    const publishedList = sentimentQuestionListItems && sentimentQuestionListItems.filter((q => q.status == 'published')).sort((a, b) => a.orderWeight - b.orderWeight); 
    const draftList = sentimentQuestionListItems && sentimentQuestionListItems.filter((q => q.status == 'draft'));
    const archivedList = sentimentQuestionListItems && sentimentQuestionListItems.filter((q => q.status == 'archived'));

    return (
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <Breadcrumbs links={location.state.breadcrumbs} />
              <h1> Sentiment Question List
                <Link className={"yt-btn small u-pullRight"} to={'/admin/sentiment-questions/new'}> NEW Sentiment Question </Link>
              </h1>
              <hr/>
              { isEmpty ?
                (sentimentQuestionListItems && sentimentQuestionList.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
                :
                <div style={{ opacity: sentimentQuestionList.isFetching ? 0.5 : 1 }}>
                  { publishedList && publishedList.length > 0 ? 
                    <div>
                      <h3>Published:
                      <button className={"yt-btn small slate u-pullRight"} onClick={this._toggleSentimentModal}> Preview Sentiment Modal </button>
                      </h3>
                      {publishedList.map((sentimentQuestion, i) =>
                        <SentimentQuestionListItem key={sentimentQuestion._id + i} sentimentQuestion={sentimentQuestion} />
                      )}
                    </div>
                  : null 
                  }
                  { draftList && draftList.length > 0 ? 
                    <div>
                      <h3>Drafts:</h3>
                      {draftList.map((sentimentQuestion, i) =>
                        <SentimentQuestionListItem key={sentimentQuestion._id + i} sentimentQuestion={sentimentQuestion} />
                      )}
                    </div>
                  : null
                  }
                  { archivedList && archivedList.length > 0 ? 
                    <div>
                      <h3>Archived:</h3>
                      {archivedList.map((sentimentQuestion, i) =>
                        <SentimentQuestionListItem key={sentimentQuestion._id + i} sentimentQuestion={sentimentQuestion} />
                      )}
                    </div>
                  : null
                  }
                </div>
              }
            </div>
          </section>
          <SentimentQuestionPreviewModal
            closeModal={() => this.setState({sentimentModalVisible: false})}
            dispatch={this.props.dispatch}
            isOpen={this.state.sentimentModalVisible}
            questionList={publishedList}
          />
        </div>
    )
  }
}

SentimentQuestionList.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    sentimentQuestionStore: store.sentimentQuestion
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(SentimentQuestionList)
);



// WEBPACK FOOTER //
// modules/sentimentQuestion/views/SentimentQuestionList.js.jsx